import { Injectable } from '@angular/core';
import {NotificationService} from '@progress/kendo-angular-notification';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import {LanguagesService} from './languages.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(private notification: NotificationService, private dialog: DialogService, private lang: LanguagesService) { }

  public info(message, duration= 2000): void{
    this.notification.show({
      content: message,
      hideAfter: duration,
      animation: { type: 'slide', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'info', icon: true },
    });
  }

  public success(message, duration = 2000): void{
    this.notification.show({
      content: message,
      hideAfter: duration,
      animation: { type: 'slide', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'success', icon: true },
    });
  }

  public warning(message, duration = 4000, closable= false): void {
    this.notification.show({
      content: message,
      hideAfter: duration,
      animation: { type: 'slide', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'warning', icon: true },
      closable
    });
  }

  public error(message, width = 800): void {
    const dialog: DialogRef = this.dialog.open({
      title: this.lang.define.lib.error,
      content: message,
      actions: [
        { text: this.lang.define.lib.close, primary: true }
      ],
      width,
      minWidth: 600
    });
  }

  public confirm(message, onResult: (result: boolean) => void): void {
    const dialog: DialogRef = this.dialog.open({
      title: this.lang.define.lib.confirm,
      content: message,
      actions: [
        { text: this.lang.define.lib.no, value: false },
        { text: this.lang.define.lib.yes, primary: true, value: true }
      ],
      width: 450,
      height: 200,
      minWidth: 250
    });

    dialog.result.subscribe((result) => {
      onResult((result as {[key: string]: any}).value);
    });
  }

}
